import React, { useEffect } from 'react';
import { initGA, usePageTracking } from '../../lib/analytics';

export function GoogleAnalytics() {
  useEffect(() => {
    initGA();
  }, []);

  usePageTracking();

  return null;
}